import { API_URL } from './Constants';
import ApiService from './ApiService';


class AdminApi {
    static getListTinTucAdmin = async (pageNumber, postType, catId, titleSearch) => {
        try {
            // Initialize params with mandatory parameter
            let params = { pageNumber };

            // Add optional parameters only if they are not null or undefined
            if (postType != null) params.postType = postType;
            if (catId != null) params.catId = catId;
            if (titleSearch != null && titleSearch.trim() !== "") params.titleSearch = titleSearch;

            return await ApiService.getDataWithParams(API_URL + "/tin-tuc/admin/list", params);
        } catch (error) {
        }
    };

    static deletePost = async (postId) => {
        try {
            let url = `/tin-tuc/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
        }
    };

    static deleteVideoPost = async (postId) => {
        try {
            let url = `/video/admin/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
        }
    };

    static deleteAudioPost = async (postId) => {
        try {
            let url = `/audio/admin/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
        }
    };

    static deleteKinhSachPost = async (postId) => {
        try {
            let url = `/kinh-sach/admin/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
        }
    };

    static deleteThongBaoPost = async (postId) => {
        try {
            let url = `/thong-bao/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
        }
    };

    static deleteHinhAnhPost = async (postId) => {
        try {
            let url = `/hinh-anh/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
        }
    };

    static deleteGiangSuPost = async (postId) => {
        try {
            let url = `/giang-su/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
        }
    };

    static deleteTrangPost = async (postId) => {
        try {
            let url = `/trang/admin/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
        }
    };

    static deleteNhacPhatGiaoPost = async (postId) => {
        try {
            let url = `/nhac-phat-giao/admin/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
        }
    };

    static deleteSachNoiPost = async (postId) => {
        try {
            let url = `/sach-noi/admin/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
        }
    };

    static deleteGuongSangTuHanhPost = async (postId) => {
        try {
            let url = `/guong-sang-tu-hanh/admin/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
        }
    };

    static deleteAudioTheoBoPost = async (postId) => {
        try {
            let url = `/audio-theo-bo/admin/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
        }
    };

    static deleteSlideShowHeaderPost = async (postId) => {
        try {
            let url = `/slideshow-header/admin/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
        }
    };

    static deleteSlideShowHomePost = async (postId) => {
        try {
            let url = `/slideshow-home/admin/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
        }
    };

    // ---------------- MEDIA FILE -------------------
    static getMediaFile = async (postId) => {
        try {
            let url = `/hinh-anh/media/list/${postId}`
            const response = await ApiService.getDataWithParams(API_URL + url);
            return response;
        } catch (error) {
        }
    };

    static deleteMediaFile = async (postId) => {
        try {
            let url = `/hinh-anh/media/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
        }
    };

    // ---------------- SYSTEM MANAGEMENT -------------------
    static getSettings = async () => {
        return await ApiService.getDataWithParams(API_URL + "/settings");
    };

    static getSettingGroups = async () => {
        return await ApiService.getDataWithParams(API_URL + "/setting-groups");
    };

    static getMenus = async () => {
        return await ApiService.getDataWithParams(API_URL + "/menus");
    };

    static getMenuItems = async () => {
        return await ApiService.getDataWithParams(API_URL + "/menu-items");
    };

    static getRoles = async () => {
        return await ApiService.getDataWithParams(API_URL + "/roles");
    };

    static getPermissions = async () => {
        return await ApiService.getDataWithParams(API_URL + "/permissions");
    };

    static getAccountList = async () => {
        return await ApiService.getDataWithParams(API_URL + "/account/list");
    };

    static getEmails = async () => {
        return await ApiService.getDataWithParams(API_URL + "/emails");
    };

    static getEmailSubscribes = async () => {
        return await ApiService.getDataWithParams(API_URL + "/email-subscribes");
    };

    static updateEmail = async (id, emailData) => {
        return await ApiService.putData(API_URL + "/emails/" + id, emailData);
    };

    // ---------------- MEMBER MANAGEMENT -------------------
    static getMemberList = async () => {
        return await ApiService.getDataWithParams(API_URL + "/admin/members/list");
    };

    static updateMemberRole = async (userId, roleId) => {
        return await ApiService.putData(API_URL + `/admin/members/${userId}/role?roleId=${roleId}`);
    };

    static deleteMember = async (userId) => {
        return await ApiService.deletePost(API_URL + `/admin/members/${userId}`);
    };

    static createMember = async (memberData) => {
        return await ApiService.postData(API_URL + "/admin/members/create", memberData);
    };

    // ---------------- ROLE & PERMISSION -------------------
    static getRoles = async () => {
        return await ApiService.getDataWithParams(API_URL + "/roles");
    };

    static getRoleById = async (id) => {
        return await ApiService.getDataWithParams(API_URL + "/roles/" + id);
    };

    static saveRole = async (roleData) => {
        if (roleData.roleid) {
            return await ApiService.putData(API_URL + "/roles/" + roleData.roleid, roleData);
        }
        return await ApiService.postData(API_URL + "/roles", roleData);
    };

    static deleteRole = async (id) => {
        return await ApiService.deletePost(API_URL + "/roles/" + id);
    };

    static getPermissions = async () => {
        return await ApiService.getDataWithParams(API_URL + "/permissions");
    };

    static getRolePermissions = async (roleId) => {
        return await ApiService.getDataWithParams(API_URL + "/admin/role-permissions/" + roleId);
    };

    static updateRolePermissions = async (roleId, permissions) => {
        return await ApiService.postData(API_URL + "/admin/role-permissions/" + roleId, permissions);
    };
}

export default AdminApi;